import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/forge/www.medkart.in/releases/82082909/components/MainLayout/MainLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/forge/www.medkart.in/releases/82082909/components/PageComponent/PageLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/forge/www.medkart.in/releases/82082909/context/AppStateContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/forge/www.medkart.in/releases/82082909/node_modules/next/dist/client/script.js");
